/**
 * TanStack Query Provider Configuration
 *
 * Configures the QueryClient with default options for the application.
 * Uses v5 patterns with gcTime (not cacheTime) and proper defaults.
 */

import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient singleton instance
 *
 * Default options:
 * - staleTime: 5 minutes (prevents excessive refetches)
 * - gcTime: 30 minutes (how long inactive data stays in cache)
 * - retry: 3 (default retry count for failed queries)
 * - refetchOnWindowFocus: true (refetch when user returns to tab)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (v5: renamed from cacheTime)
      retry: 3,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
